import { Col, Row, Space } from 'antd';
import React from 'react';

const ProductImage = function () {
  return (
    <Row
      justify="center"
      style={{ padding: 48, backgroundColor: '#00B0F0', marginBottom: 24 }}
    >
      <Col span={24} xs={24} sm={24}>
        <Space orientation="vertical" align="center" style={{ width: '100%' }}>
          <img
            src="https://cdn.guuru.com/assets/logo/guuru_horizontal_white.png"
            width="180px"
            alt="Guuru - Humanize your brand"
          />
        </Space>
      </Col>
    </Row>
  );
};

export default ProductImage;
